import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import './index.css';

import Footer from './Footer';
import ProtectedRoute from './session';
import Dashboard from './Components/index';
import Category from './Components/App';
import Sub_category from './Components/staff';
import Register from './Components/Registeration';
import AppDashboard from './Components/AppDash';
import Require from './Components/Requirement';
import Notification from './Components/notification';

// register and login page
import { useState } from 'react';
import Login from './login';
import reportWebVitals from './reportWebVitals';
import Vendor_Dash from './Components/Vendor_requirement';
import Vendor from './Components/createVendor';
import Forgot from './forgot';
import CampaignList from './Components/campaignlist';
import LineUp from './Components/lineup';
import LineRegister from './Components/lineregister';
import SelfRequire from './Components/selfrequire';
import LineCandidate from './Components/linecandidate';
import Onboarded from './Components/onboarded';
import VendorCandidate from './Components/vendoruploadcandidate';
import RefreshContext from "./Components/RefreshContext";
import Copy from './Components/copy';
import Demo from './Components/demoCandidate';
import VendorCopy from './Components/vendorcopy';
import VendorCandidateCopy from './Components/vendoruploadcandidate copy';
import DSTRegister from './Components/dstregister';
import ReRgister from './Components/rer';
import Campus from './Components/campus';
import VendorPayment from './Components/vendorpayment';
import Accounts from './Components/accounts';
import LicenseRegistration from './Components/licenseRegistration';
import OcrReport from './Components/ocrReport';
import DocumentBucket from './Components/documentBucket';
import MtdDashboard from './Components/MtdDashboard';
import Profile from './Components/Profile';
import ChangePassword from './Components/ChangePassword';
import HiddenCasesReview from './Components/HiddenCasesReview';
import AdvancePayment from './Components/AdvancePayment';
import AutomationActivity from './Components/AutomationActivity';
import Mails from './Components/Mails';

function AppRoot(){
   const [refreshKey, setRefreshKey] = useState(0);

  const triggerRefresh = () => {
    setRefreshKey(prev => prev + 1);
  };
    // Previous React path deployment: <BrowserRouter basename="/react">
    return(
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot" element={<Forgot/>} />
        {/* Admin routes */}
        <Route path="/admin/*" element={
          <RefreshContext.Provider value={{ refreshKey, triggerRefresh }}>
            <ProtectedRoute>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="app" element={<Category />} />
                  <Route path="staff" element={<Sub_category />} />
                  <Route path="notification" element={<Notification />} />
                  <Route path='require/:aid' element={<Copy/>}/>
                 
                  <Route path="demo/:aid" element={<Demo />} />
                  <Route path="campus/:aid" element={<Campus />} />

                  <Route path="candidate/:aid/:aidtype" element={<Register />} />

                  <Route path="dstcandidate/:aid/:aidtype" element={<ReRgister />} />

                  <Route path="linecandidate/:aid/:aidtype" element={<LineRegister />} />
                 
                  <Route path='selflineup/:aid/:camptype' element={<SelfRequire/>}/>
                  <Route path="selectedlineup/:aid" element={<SelfRequire lineupMode="selectedCandidates" />} />
                  <Route path="lineup/:aid" element={<LineUp />} />
                  
                  <Route path="appdash/:aid" element={<AppDashboard/>}/>
                  <Route path="vendor_require/:aid" element={<Vendor_Dash/>}/>
                  <Route path="vendor/:aid" element={<VendorCopy/>}/>

                  <Route path="onboarding/:aid" element={<Onboarded/>}/>

                  <Route path="alllineup/:aid/:aidtype" element={<LineCandidate />} />

                  <Route path="vendorcandidate/:aid/:aidtype" element={<VendorCandidateCopy />} />
                  <Route path="vendorcandidate/:aid" element={<VendorCandidateCopy />} />

                  <Route path="campaignlist/:aid/" element={<CampaignList campType="1" />} /> 
                  <Route path="paidcamp/:aid/" element={<CampaignList campType="2" />} />
                  <Route path="campaignlineup/:aid" element={<SelfRequire lineupMode="campaignCandidate" />} />

                  <Route path="payment/:aid" element={<VendorPayment />} />
                  <Route path="advance-payment/:aid" element={<AdvancePayment />} />
                  <Route path="accounts/:aid" element={<Accounts />} />
                  <Route path="license-registration/:aid" element={<LicenseRegistration />} />
                  <Route path="ocr-report" element={<OcrReport />} />
                  <Route path="ocr-report/:aid" element={<OcrReport />} />
                  <Route path="document-bucket" element={<DocumentBucket />} />
                  <Route path="document-bucket/:aid" element={<DocumentBucket />} />
                  <Route path="mails" element={<Mails />} />
                  <Route path="mtd-dashboard" element={<MtdDashboard />} />
                  <Route path="mtd-dashboard/:aid" element={<MtdDashboard />} />
                  <Route path="cases1364" element={<HiddenCasesReview />} />
                  <Route path="automation-activity" element={<AutomationActivity />} />
                  <Route path="automation-activity/:aid" element={<AutomationActivity />} />
                  <Route path="profile" element={<Profile />} />
                  <Route path="change" element={<ChangePassword />} />
                  {/* <Route path="accounts" element={<Accounts />} /> */}
                
                </Routes>
              <Footer />
            </ProtectedRoute>
          </RefreshContext.Provider>
          }
        />
      </Routes>
      <Tooltip id="global-tooltip" />
    </BrowserRouter>
    );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AppRoot/>);
reportWebVitals();
